import { render } from "./customDimensions.vue?vue&type=template&id=232e8a09"
import script from "./customDimensions.vue?vue&type=script&lang=js"
export * from "./customDimensions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__